import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    // Add click listeners to all delete buttons
    this.element.querySelectorAll('.delete-photo-btn').forEach(button => {
      button.addEventListener('click', this.togglePhotoRemoval.bind(this))
    })
  }

  disconnect() {
    // Clean up listeners
    this.element.querySelectorAll('.delete-photo-btn').forEach(button => {
      button.removeEventListener('click', this.togglePhotoRemoval.bind(this))
    })
  }

  togglePhotoRemoval(event) {
    event.preventDefault()
    event.stopPropagation()
    
    const button = event.currentTarget
    const photoId = button.dataset.photoId
    const photoContainer = button.closest('.existing-file')
    const checkbox = photoContainer.querySelector(`#remove_photo_${photoId}`)
    const overlay = photoContainer.querySelector('.deletion-overlay')
    const image = photoContainer.querySelector('.photo-image')
    
    if (checkbox.checked) {
      // Unmark for deletion
      checkbox.checked = false
      overlay.classList.add('hidden')
      image.classList.remove('opacity-40')
      photoContainer.classList.remove('ring-2', 'ring-red-500')
      button.classList.remove('bg-green-500', 'hover:bg-green-600')
      button.classList.add('bg-red-500', 'hover:bg-red-600')
      button.innerHTML = '<i class="fa-solid fa-times text-xs"></i>'
    } else {
      // Mark for deletion
      checkbox.checked = true
      overlay.classList.remove('hidden')
      image.classList.add('opacity-40')
      photoContainer.classList.add('ring-2', 'ring-red-500')
      button.classList.remove('bg-red-500', 'hover:bg-red-600')
      button.classList.add('bg-green-500', 'hover:bg-green-600')
      button.innerHTML = '<i class="fa-solid fa-rotate-left text-xs"></i>'
    }
  }
}